import { useParams } from "react-router-dom";
import { DatasetDiff } from "admin/components/dataset-detail/types/dataset-diff";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

const useDatasetDiff = () => {
  const { datasetId } = useParams();
  return useFetcher<DatasetDiff>(
    datasetId ? `${VITE_CATALOG_API}/datasets/${datasetId}/diff` : null,
    {
      withGlobalErrorHandler: true,
    }
  );
};

export default useDatasetDiff;
